import React from 'react'
import PropTypes from 'prop-types'

const Error = ({ width = 32, height = 32 }) => (
  <svg xmlns='http://www.w3.org/2000/svg' width={width} height={height}>
    <g data-name='Error 1' fill='#fb0f26'>
      <path
        data-name='Ellipse 428'
        d='M16 1A15 15 0 0 0 5.393 26.607 15 15 0 1 0 26.607 5.393 14.9 14.9 0 0 0 16 1m0-1A16 16 0 1 1 0 16 16 16 0 0 1 16 0Z'
      />
      <path
        data-name='Path 15290'
        d='m16.869 9.909-.128 9.409h-1.482l-.128-9.409ZM16 23.1a1.107 1.107 0 0 1-.812-.337 1.107 1.107 0 0 1-.339-.812 1.107 1.107 0 0 1 .339-.811A1.107 1.107 0 0 1 16 20.8a1.107 1.107 0 0 1 .812.339 1.107 1.107 0 0 1 .339.812 1.1 1.1 0 0 1-.157.575 1.2 1.2 0 0 1-.415.419A1.1 1.1 0 0 1 16 23.1Z'
      />
    </g>
  </svg>
)

Error.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number
}

export default Error
